// Email = the unified inbox filtered to email threads — ONE email-composing
// experience (the inbox reply composer: branded send path, reply threading,
// identity line), not a second standalone compose form whose sent log never
// persisted. Bulk/templated email lives in Segment Outreach.
import React from "react";
import UnifiedInbox from "../Inbox/UnifiedInbox";

export default function EmailPage() {
  return <UnifiedInbox initialFilter="email" />;
}
